import { topicsData } from '@/mocks/home-data';

const trendIcons: Record<string, string> = {
  'up': 'ri-arrow-up-line text-accent-500',
  'hot': 'ri-fire-line text-primary-500',
  'new': 'ri-sparkling-line text-secondary-600',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-2">话题广场</h2>
          <p className="text-sm text-foreground-600">全网热议话题实时追踪 · 吃瓜群众聚集地</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {topicsData.map((topic) => (
            <div
              key={topic.id}
              className="flex flex-col gap-2 p-4 md:p-5 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug">
                {topic.name}
              </h3>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-500">{topic.heat}</span>
                <span className={`w-6 h-6 flex items-center justify-center`}>
                  <i className={`${trendIcons[topic.trend] || 'ri-arrow-up-line text-foreground-400'} text-sm`}></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}